import {
    Component,
    h,
    Host,
    Prop,
} from '@stencil/core';
import { ThemeType } from '@uipath/portal-shell-util';

import store from '../../store/store';
import { idToSvg } from '../../utils/serviceIconHelper/serviceIconHelper';
import { getTheme } from '../../utils/themeHelper';
import basic_auth_user from './assets/basic_auth_user.svg';
import burger from './assets/burger.svg';
import directory_app from './assets/directory_app.svg';
import directory_group from './assets/directory_group.svg';
import directory_user from './assets/directory_user.svg';
import error from './assets/error.svg';
import expand_message from './assets/expand_message.svg';
import info from './assets/info.svg';
import local_group from './assets/local_group.svg';
import robot from './assets/robot.svg';
import success from './assets/success.svg';
import waffle from './assets/waffle.svg';
import warning from './assets/warning.svg';

@Component({
    tag: 'portal-custom-icon',
    styleUrl: 'portal-custom-icon.scss',
    shadow: true,
})
export class PortalCustomIcon {
    /**
     * Name of the icon
     * @memberof PortalCustomIcon
     */
    @Prop() name = '';

    /**
     * Aria Label of the icon
     * @memberof PortalCustomIcon
     */
    @Prop() ariaLabel: ARIAMixin['ariaLabel'];

    /**
     * Size of the icon
     * @memberof PortalCustomIcon
     */
    @Prop() size = '16px';

    /**
     * Add custom color
     * @memberof PortalCustomIcon
     */
    @Prop() color = 'var(--color-foreground-de-emp)';

    /**
    * Theme override to bypass store state
    * @memberof PortalCustomIcon
    */
    @Prop() theme: ThemeType = 'autoTheme';

    private iconMap = {
        'error': error,
        'info': info,
        'success': success,
        'warning': warning,
        'basic_auth_user': basic_auth_user,
        'local_group': local_group,
        'robot': robot,
        'directory_user': directory_user,
        'directory_group': directory_group,
        'directory_app': directory_app,
        'expand_message': expand_message,
        'waffle': waffle,
        'burger': burger,
        ...idToSvg,
    };

    render() {
        return (<Host class={getTheme(store, this.theme)}>
            <div
                data-cy="portal-custom-icon"
                data-test="portal-custom-icon"
                style={{
                    '--icon-size': this.size,
                    '--icon-color': this.color,
                }}
                role="img"
                aria-label={this.ariaLabel ?? 'portal-icon'}
                class="portal-custom-icon"
                innerHTML={this.iconMap[this.name]}
            />
        </Host>);
    }
}
